import { IDexTrade } from '@kattana-io/common';
import { action } from 'typesafe-actions';
import { IMeta } from '../reducers/dex_trades';

const entity = 'dex_trades';
const ACTION_CLEAR = `${entity}/CLEAR`;
const ACTION_REPLACE = `${entity}/ADD_TRADE`;
const ACTION_APPEND = `${entity}/APPEND_TRADES`;
const ACTION_LOAD_TRADES = `${entity}/LOAD_TRADES`;
const ACTION_BEFORE_ADD_TRADE = `${entity}/BEFORE_ADD_TRADE`;
const ACTION_ADD_TRADE = `${entity}/APPEND_TRADE`;
const ACTION_UPDATE_META = `${entity}/UPDATE_META`;

const actionClearDexTrades = () =>
  action(ACTION_CLEAR);

const actionLoadTrades = () =>
  action(ACTION_LOAD_TRADES);

const actionUpdateDexHistory = (state: any) =>
  action(ACTION_REPLACE, state);

const actionAppendDexHistory = (data: IDexTrade[]) =>
  action(ACTION_APPEND, data);

const actionBeforeAppendTrade = (data: IDexTrade) =>
  action(ACTION_BEFORE_ADD_TRADE, data);

const actionAppendTrade = (data: IDexTrade) =>
  action(ACTION_ADD_TRADE, data);

const actionUpdateTradesMeta = (meta: IMeta) =>
  action(ACTION_UPDATE_META, meta);

export {
  ACTION_CLEAR,
  ACTION_REPLACE,
  ACTION_APPEND,
  ACTION_ADD_TRADE,
  ACTION_LOAD_TRADES,
  ACTION_BEFORE_ADD_TRADE,
  ACTION_UPDATE_META,
  actionClearDexTrades,
  actionUpdateDexHistory,
  actionAppendDexHistory,
  actionAppendTrade,
  actionBeforeAppendTrade,
  actionLoadTrades,
  actionUpdateTradesMeta,
};